export const VALOR_MIN = 2.5;
export const VALOR_MAX = 1000000;
